export default __webpack_public_path__ + "static/media/group-6266.b2822133.svg";